import { render, staticRenderFns } from "./PageProduction.vue?vue&type=template&id=8bb32dd8&"
import script from "./PageProduction.vue?vue&type=script&lang=js&"
export * from "./PageProduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bb32dd8')) {
      api.createRecord('8bb32dd8', component.options)
    } else {
      api.reload('8bb32dd8', component.options)
    }
    module.hot.accept("./PageProduction.vue?vue&type=template&id=8bb32dd8&", function () {
      api.rerender('8bb32dd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Production/PageProduction.vue"
export default component.exports